"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ElevateYourBrand() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="163046" id="start-your-connection" className="bg-[#0a1221] bg-gradient-to-br from-[#0a1221] via-[#111d35] to-[#0a1221] text-white py-32 md:py-48 lg:py-64 px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center text-center overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto space-y-12 md:space-y-16 transition-all duration-1000 ease-out transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0"}`}>
        <h2 className="font-sans text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-extrabold uppercase leading-[0.85] tracking-tighter">
          One connection is all it takes.
        </h2>
        
        <div className="pt-4">
          <Button asChild size="lg" className="bg-[#f59e0b] text-[#0a1221] hover:bg-white hover:text-[#0a1221] text-lg md:text-xl h-auto px-10 py-6 rounded-full uppercase font-bold tracking-widest transition-all duration-300 border-2 border-transparent hover:scale-105 shadow-xl">
            <Link to="/ContactPage">Get started today</Link>
          </Button>
        </div>
      </div>
    </section>;
}